export const theme = {
  color: {
    Maincolor:
      "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);",
    ColorText: "#BDBDBD",
    HeaderSlidecolor: "#757575",
    HeaderLogocolor: "#F5F5F5",
    ButtonColor: "#536DFE",
    primaryBackGround:
      "linear-gradient(90deg, rgb(7 119 113 / 0%), rgb(37 177 179 / 76%), rgb(99 64 162 / 0%))",
    primaryColor: "#212121",
    fistaryColor: "#253069",
    secondaryColor: "#ffffff",
    // overlay: '#626464',
    overlay: "rgba(98, 100, 100, 0.2)",
    buttonaccentColor: "#D6372E",
    accentColorHover: "rgba(255, 215, 0, 0.5)",
    primaryColorBtn: "#2A5EA8",
    secondaryColorBtn: "#0C5FAE",
    primaryBackGroundBtn: "#212121",

    borderColor: "#373737",

    cardBackGround: "#c4c4c4",

    mobileLinkBtn: "rgba(0, 0, 0, 1)",
    mobileMenu: "rgba(255, 215, 0, 1)",
    mobileLogo: "rgba(43, 45, 46, 1)",
    error: "#ff0000",

    transition: "cubic-bezier(0.4, 0, 0.2, 1)",
    eventsListArrow: "#747778",
    examplePx: "30px",
  },
};
